export default __webpack_public_path__ + "static/media/meus-culture.00adce30.png";